var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-home"},[_c('HomeView',{attrs:{"width":_vm.width,"height":_vm.height - 100}}),_c('section-sale',{attrs:{"height":_vm.height - 100}}),_c('about-us',{attrs:{"height":_vm.height - 100}}),_c('why-choose-us',{attrs:{"height":_vm.height}}),_c('banner-rental'),_c('our-proposals',{attrs:{"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }